export const BREAKPOINT = {
  sm: 640,
  md: 768,
  lg: 1024,
};
